import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getAppViewUser } from '../app/store/appViewSlice';
import WelcomeDialog from './WelcomeDialog';

// Local storage keys
const ONBOARDING_COMPLETED_KEY = 'onboarding_completed';
const IS_NEW_USER_KEY = 'is_new_user';

const NewUserOnboarding: React.FC = () => {
  const user = useSelector(getAppViewUser);
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    if (!user) return;

    console.log(
      'NewUserOnboarding: Checking onboarding status for',
      user.email,
    );

    // Check if onboarding is already completed
    const isOnboardingCompleted = localStorage.getItem(
      `${ONBOARDING_COMPLETED_KEY}_${user.email}`,
    );

    // Check if this is a new user
    const isNewUser = localStorage.getItem(`${IS_NEW_USER_KEY}_${user.email}`);

    console.log('Onboarding status:', {
      isNewUser,
      isOnboardingCompleted,
      user,
    });

    // For debugging: Uncomment these lines to test the dialog
    // localStorage.removeItem(`${ONBOARDING_COMPLETED_KEY}_${user.email}`);
    // localStorage.setItem(`${IS_NEW_USER_KEY}_${user.email}`, 'true');

    // Show dialog if user is new and hasn't completed onboarding
    if (user && isNewUser && !isOnboardingCompleted) {
      console.log('Will show onboarding dialog');

      // Small delay to ensure app is loaded first
      const timer = setTimeout(() => {
        setShowDialog(true);
      }, 1000);

      return () => clearTimeout(timer);
    } else {
      // If user has already completed onboarding, make sure we clean up the new user flag
      if (isOnboardingCompleted && isNewUser) {
        console.log(
          'User already completed onboarding, cleaning up new user flag',
        );
        localStorage.removeItem(`${IS_NEW_USER_KEY}_${user.email}`);
      }

      // Ensure dialog is hidden - prevents reappearing issues
      setShowDialog(false);
    }
  }, [user]);

  const handleCloseDialog = () => {
    console.log('Closing onboarding dialog and saving completion status');

    if (user) {
      // Mark onboarding as completed
      localStorage.setItem(`${ONBOARDING_COMPLETED_KEY}_${user.email}`, 'true');

      // Clear the new user flag so it won't show again
      localStorage.removeItem(`${IS_NEW_USER_KEY}_${user.email}`);
      console.log('Cleaned up localStorage flags for', user.email);
    }

    setShowDialog(false);
  };

  if (!user) return null;

  // Use a key that's stable for the component but changes when the dialog should reappear
  const dialogKey = `welcome-dialog-${user.email}`;

  return (
    <WelcomeDialog
      key={dialogKey}
      isOpen={showDialog}
      onClose={handleCloseDialog}
      userData={user}
    />
  );
};

export default NewUserOnboarding;
